const styles = (theme) => ({
    container: {
        background: `${theme.palette.primary.main} linear-gradient(rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.7)) 50%`,
        borderRadius: '5px',
    },
    header: {
        paddingTop: '100px',
        paddingBottom: '50px',
    },
    logoSection: {
        padding: '0 30px',
    },
    logoContainer: {
        borderRadius: '50%',
    },
    logo: {
        width: '75px',
        height: '75px',
        objectFit: 'cover',
        borderRadius: '50%',
    },
    title: {
        fontWeight: 600,
        color: '#fff',
        padding: '5px 30px',
    },
    body: {
        color: '#fff',
        padding: '35px 30px',
    },
    createBtn: {
        padding: '10px 30px',
        marginLeft: '30px',
        textTransform: 'none',
    },
    textSection: {
        maxWidth: '350px',
    },
});

export default styles;
